import { trellisColors } from '../theme'

export const HomePage = () => (
  <main
    style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '1.5rem',
      padding: '2rem',
      textAlign: 'center',
      backgroundColor: trellisColors.teal,
      color: trellisColors.lime,
    }}
  >
    <img src="/logo.svg" alt="Trellis logo" width={150} />
    <p style={{ margin: 0, maxWidth: '32rem', color: '#ffffff' }}>
      Welcome to the <strong>trellis</strong> app. This is a placeholder home page.
    </p>
  </main>
)
